// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #login-form #buttonPallet {
    background-color: transparent !important;
}

#buttonPallet button {
    background-color: #5cae48;
} */


.register_wrap.bg-darkblue {
	background: #0d3453;
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	align-items: center;
	justify-content: center;
}
.login_wrapper.full_page_login {padding: 50px;background: #fff;border-radius: 5px;}

.login_wrapper.full_page_login + .fpw_wrapper {padding: 50px;background: #fff;border-radius: 5px;}

.view_pw a.btn {
    position: absolute;
    right: 15px;
    top: 0;
    bottom: 0;
    height: 20px;
    padding: 0;
    display: flex;
    margin: auto;
    align-items: center;
  }
  .view_pw > a.btn img {
    width: 20px;
    height: auto;
  }


  .view_pw {
	position: relative;
}

#InputPassword[type="password"] + a .fview_icn {
	display: none;
}

#InputPassword[type="text"] + a .fview_strike_icn {
	display: none;
}
.login_footer {display: flex;justify-content: space-between;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;position: absolute;left: 0;bottom: 35px;width: 100%;}
.login_footer .powerby {width: auto;min-width: initial !important;}

.border-top-7b {
	border-top: 1px solid #124d7b !important;
}`, "",{"version":3,"sources":["webpack://./src/features/admin/login/styles.css"],"names":[],"mappings":"AAAA;;;;;;GAMG;;;AAGH;CACC,mBAAmB;CACnB,aAAa;CACb,sBAAsB;CACtB,iBAAiB;CACjB,mBAAmB;CACnB,uBAAuB;AACxB;AACA,gCAAgC,aAAa,CAAC,gBAAgB,CAAC,kBAAkB,CAAC;;AAElF,+CAA+C,aAAa,CAAC,gBAAgB,CAAC,kBAAkB,CAAC;;AAEjG;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,YAAY;IACZ,UAAU;IACV,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;EACd;;;EAGA;CACD,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;AACA,eAAiG,aAAa,CAAC,8BAA8B,CAAC,sBAAsB,CAAC,mBAAmB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,CAAC,kBAAkB,CAAC,OAAO,CAAC,YAAY,CAAC,WAAW,CAAC;AACpS,wBAAwB,WAAW,CAAC,6BAA6B,CAAC;;AAElE;CACC,wCAAwC;AACzC","sourcesContent":["/* #login-form #buttonPallet {\n    background-color: transparent !important;\n}\n\n#buttonPallet button {\n    background-color: #5cae48;\n} */\n\n\n.register_wrap.bg-darkblue {\n\tbackground: #0d3453;\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-height: 100vh;\n\talign-items: center;\n\tjustify-content: center;\n}\n.login_wrapper.full_page_login {padding: 50px;background: #fff;border-radius: 5px;}\n\n.login_wrapper.full_page_login + .fpw_wrapper {padding: 50px;background: #fff;border-radius: 5px;}\n\n.view_pw a.btn {\n    position: absolute;\n    right: 15px;\n    top: 0;\n    bottom: 0;\n    height: 20px;\n    padding: 0;\n    display: flex;\n    margin: auto;\n    align-items: center;\n  }\n  .view_pw > a.btn img {\n    width: 20px;\n    height: auto;\n  }\n\n\n  .view_pw {\n\tposition: relative;\n}\n\n#InputPassword[type=\"password\"] + a .fview_icn {\n\tdisplay: none;\n}\n\n#InputPassword[type=\"text\"] + a .fview_strike_icn {\n\tdisplay: none;\n}\n.login_footer {display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;justify-content: space-between;-webkit-box-wrap: wrap;-moz-box-wrap: wrap;-ms-flex-wrap: wrap;-webkit-wrap: wrap;flex-wrap: wrap;position: absolute;left: 0;bottom: 35px;width: 100%;}\n.login_footer .powerby {width: auto;min-width: initial !important;}\n\n.border-top-7b {\n\tborder-top: 1px solid #124d7b !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
